import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import ShootoutAttempt from "./Attempt";

const useStyles = makeStyles(() => ({
  center: {
    textAlign: 'center',
  },
}));

function Shootout({ teams, shootout, skaters }) {
  const classes = useStyles();
  return (
    <Grid container>
      <Grid item className={classes.center} xs={12}>
        <Typography variant="overline" component="p">Shootout</Typography>
      </Grid>
      <Grid item xs={6}>
        <TeamShootout attempts={shootout[teams.visitor]} skaters={skaters} />
      </Grid>
      <Grid item xs={6}>
        <TeamShootout isHome attempts={shootout[teams.home]} skaters={skaters} />
      </Grid>
    </Grid>
  )
}

function TeamShootout({ attempts, isHome, skaters }){
  return (
    <Grid container>
      { attempts.map(attempt => (
        <Grid key={attempt.id} item xs={12}>
          <ShootoutAttempt isHome={isHome} attempt={attempt} skaters={skaters} />
        </Grid>
      ))}
    </Grid>
  )
}

export default Shootout;
